import { Link as LinkIcon, Calendar, MoveUpRight } from 'lucide-react';
import QuickAccessLinkItem from '../cards/QuickAccessLinkItem';
import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';

const QuickAccessLinksSection = ({ links: propLinks, cta }) => {
    const links = propLinks || [
        {
            icon: <LinkIcon size={24} />,
            title: 'Weekly Feedback Form',
            description: 'Help us improve your experience',
            href: 'https://teable.zinduaschool.com/share/shrJwV3ugJ5iC9UWFyG/view',
        },
        {
            icon: <LinkIcon size={24} />,
            // title: "Deferral/Withdrawal Request", // Test
            title: 'Post Module Feedback', // Prod
            description: 'Routes to your Program Manager',
            href: 'https://teable.zinduaschool.com/share/shrm4CtjhesAtA2toHs/view',
        },
        // {
        //     icon: <LinkIcon size={24} />,
        //     // title: "Request Refund", // Test
        //     title: 'Deferral or Withdrawal Request', // Prod
        //     // description: "For overpayment or after withdrawal", // Test
        //     description: 'For deferment or Withdraw from a Program', // Prod
        //     href: '#',
        // },
        {
            icon: <Calendar size={24} />,
            title: 'Upcoming Events/Webinars',
            description: "View calendar on Zindua's Luma",
            href: 'https://lu.ma/zinduaschool',
        },
        {
            icon: <Calendar size={24} />,
            title: 'Upcoming Tech Masterclasses',
            description: 'Free for Zindua core students',
            href: 'https://zinduaschool.com/masterclasses',
        },
    ];

    const ctaLink = cta || { to: '/coming-soon', text: 'View Public Profile' };

    return (
        <div className="border border-neutral-300 rounded-lg">
            <div className="pt-4 px-4 pb-2">
                <h4 className="mb-1 capitalize">Quick Access Links</h4>
                <p className="text-neutral-700 capitalize">Click any item below to be directed there</p>
            </div>
            <div className="flex flex-col justify-start items-start mt-2">
                {links.map((link, index) => (
                    <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="w-full no-underline">
                        <QuickAccessLinkItem {...link} index={index} totalItems={links.length} skipAnchor={true} />
                    </a>
                ))}
            </div>

            <div className="mb-2">
                <Link to={ctaLink.to} preload="intent" preloadDelay={0}>
                    <Button
                        variant="link"
                        className="w-full font-semibold flex items-center justify-center gap-2 mt-1 rounded-none rounded-b-lg"
                    >
                        <span>{ctaLink.text}</span>
                        <MoveUpRight size={20} />
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default QuickAccessLinksSection;
